import { DomainError } from '@dma/shared';

export class InvalidAboutContentError extends DomainError {
  constructor(reason: string) {
    super('INVALID_ABOUT_CONTENT', `About content is invalid: ${reason}`);
    this.name = 'InvalidAboutContentError';
    Object.setPrototypeOf(this, InvalidAboutContentError.prototype);
  }
}
